import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '../../components/ui/card';

const FacebookListingCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState(
    'Processing Facebook authorization...'
  );

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const error = params.get('error');

      if (error) {
        setStatus('error');
        setMessage(`Facebook authorization failed: ${error}`);
        setTimeout(() => {
          window.close();
        }, 3000);
        return;
      }

      if (!code) {
        setStatus('error');
        setMessage('No authorization code received from Facebook.');
        setTimeout(() => {
          window.close();
        }, 3000);
        return;
      }

      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'FACEBOOK_LISTING_AUTH_CALLBACK', code },
          window.location.origin
        );
        setStatus('success');
        setMessage('Authorization received! You can close this window.');
        setTimeout(() => {
          window.close();
        }, 1500);
      } else {
        setStatus('error');
        setMessage(
          'Could not communicate with the main window. Please close this tab and try again.'
        );
      }
    } catch (err) {
      console.error('Facebook listing callback error:', err);
      setStatus('error');
      setMessage('An unexpected error occurred.');
      setTimeout(() => {
        window.close();
      }, 3000);
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>
            {status === 'processing' && 'Connecting Facebook...'}
            {status === 'success' && 'Success!'}
            {status === 'error' && 'Connection Failed'}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center gap-4">
            {status === 'processing' && (
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            )}
            {status === 'success' && (
              <div className="text-green-600 text-5xl">✓</div>
            )}
            {status === 'error' && (
              <div className="text-red-600 text-5xl">✗</div>
            )}
            <p className="text-center text-sm text-gray-600">{message}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FacebookListingCallback;
